/**
 * Documenso Cloud embed helpers (S19).
 * Official iframe is `/embed/sign/{token}` on the Cloud host — not AGPL source.
 */

export type DocumensoSigningEmbed = {
  host: string
  token: string
}

export const parseDocumensoSigningEmbed = (
  signingUrl?: string | null
): DocumensoSigningEmbed | null => {
  if (!signingUrl) {
    return null
  }
  try {
    const parsed = new URL(signingUrl)
    if (parsed.protocol !== 'https:') {
      return null
    }
    const match = parsed.pathname.match(/\/(?:embed\/)?sign\/([^/]+)/i)
    const token = match?.[1]?.trim()
    if (!token) {
      return null
    }
    return { host: parsed.origin, token }
  } catch {
    return null
  }
}

export const documensoEmbedSrc = (embed: DocumensoSigningEmbed): string => {
  const options = btoa(encodeURIComponent(JSON.stringify({})))
  const url = new URL(`/embed/sign/${embed.token}`, embed.host)
  return `${url.toString()}#${options}`
}
